import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Carousel from "react-bootstrap/Carousel";
import { useState } from "react";

const DefaultRegionMargin = 18;

export default function MainContentComponent() {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  const directionButtons = (direction) => {
    return (
      <button
        is="button-gazable"
        dwell-animation="ltr"
        data-gaze-region-margin={DefaultRegionMargin}
        class={direction === "Next" ? "btn btn-secondary btn-lg button-next" : "btn btn-secondary btn-lg button-prev"}
      >
        {direction}
      </button>
    );
  };

  const renderCarouselItemColumn = ({ title, description, imgSrc, altText, href }) => {
    return (
      <Col xs={{ span: 4 }}>
        <gazable-element class="card">
          <div class="card-body">
            <img alt={altText} src={imgSrc} />
            <div class="card-title h5 pt-4">{title}</div>
            <div class="card-text text-center">{description}</div>
          </div>
          <div class="card-footer">
            <a
              is="a-gazable"
              href={href}
              dwell-animation="ltr"
              data-gaze-region-margin={DefaultRegionMargin}
              class="btn btn-primary btn-lg"
            >
              Open example
            </a>
          </div>
        </gazable-element>
      </Col>
    );
  };

  return (
    <>
      <Carousel
        interval={null}
        controls={true}
        variant="dark"
        activeIndex={index}
        onSelect={handleSelect}
        style={{ height: "75vh" }}
        nextIcon={directionButtons("Next")}
        prevIcon={directionButtons("Previous")}
      >
        <Carousel.Item className="td-carousel-item">
          <Row className="pb-4 justify-content-center">
            {renderCarouselItemColumn({
              title: "Star Trail",
              description: "A web application visualizes eye-tracking data as a trail of stars.",
              imgSrc: "star-trail.png",
              altText: "Star trail screenshot",
              href: "https://star-trail.tdbrowse.net/",
            })}
            {renderCarouselItemColumn({
              title: "Gaze Trail",
              description: "A web application that visualizes eye-tracking data as a dynamic gaze trail.",
              imgSrc: "gaze-trail.png",
              altText: "Gaze trail screenshot",
              href: "/gaze-trail",
            })}
          </Row>
        </Carousel.Item>

        <Carousel.Item className="td-carousel-item">
          <Row className="pb-4 justify-content-center">
            {renderCarouselItemColumn({
              title: "Oil painting",
              description: "A browser-based interactive oil-painting application",
              imgSrc: "oil-painting.png",
              altText: "Oil painting screenshot",
              href: "/oil-painting",
            })}

            {renderCarouselItemColumn({
              title: "Interactive Nodes",
              description: "A web application that showcases interactive nodes.",
              imgSrc: "interactive-nodes.png",
              altText: "Interactive nodes screenshot",
              href: "/interactive-nodes",
            })}
          </Row>
        </Carousel.Item>

        <Carousel.Item className="td-carousel-item">
          <Row className="pb-4 justify-content-center">
            {renderCarouselItemColumn({
              title: "Spotlight Cards",
              description: "A web application that showcases interactive spotlight cards.",
              imgSrc: "spotlight-cards.png",
              altText: "Spotlight cards screenshot",
              href: "/spotlight-cards",
            })}
            {renderCarouselItemColumn({
              title: "Who Goes Woof?",
              description:
                "Learn eye-tracking interaction through fun animal sound matching. Perfect for practicing gaze control with progressive difficulty and instant feedback.",
              imgSrc: "who-goes-woof.png",
              altText: "Who goes woof screenshot",
              href: "https://who-goes-woof.tdbrowse.net/",
            })}
          </Row>
        </Carousel.Item>
        <Carousel.Item className="td-carousel-item">
          <Row className="pb-4 justify-content-center">
            {renderCarouselItemColumn({
              title: "Piano",
              description:
                "A browser-based interactive piano application with multiple sound modes and eye-tracking support.",
              imgSrc: "piano.svg",
              altText: "Piano screenshot",
              href: "https://piano.tdbrowse.net/",
            })}
            {renderCarouselItemColumn({
              title: "ColorEyes",
              description: "Web application that lets kids color pictures using their gaze.",
              imgSrc: "coloreyes.ico",
              altText: "ColorEyes screenshot",
              href: "https://coloreyes.tdbrowse.net/",
            })}
          </Row>
        </Carousel.Item>

        <Carousel.Item className="td-carousel-item">
          <Row className="pb-4 justify-content-center">
            {renderCarouselItemColumn({
              title: "4 in a Row",
              description:
                "A web application that allows users to play the classic game of 4 in a Row against another player or an AI opponent.",
              imgSrc: "4inarow.png",
              altText: "4 in a Row screenshot",
              href: "https://4-in-a-row.tdbrowse.net/",
            })}
            {renderCarouselItemColumn({
              title: "2048",
              description:
                "Use your arrow keys to move the tiles. When two tiles with the same number touch, they merge into one!",
              imgSrc: "2048.png",
              altText: "2048 screenshot",
              href: "https://2048.tdbrowse.net/",
            })}
          </Row>
        </Carousel.Item>

        <Carousel.Item className="td-carousel-item">
          <Row className="pb-4 justify-content-center">
            {renderCarouselItemColumn({
              title: "Checkers",
              description:
                "Checkers browser game player vs. AI. This project is perfect to replicate if you want to better understand the basics of JS and how it talks to HTML (the DOM).",
              imgSrc: "checkersgame.png",
              altText: "Checkers screenshot",
              href: "https://checkers.tdbrowse.net/",
            })}
            {renderCarouselItemColumn({
              title: "TicTacToe",
              description: "TicTacToe browser game. Player vs Player or Player vs Computer (three difficulties)",
              imgSrc: "tictactoe.png",
              altText: "TicTacToe screenshot",
              href: "https://tictactoe.tdbrowse.net/",
            })}
          </Row>
        </Carousel.Item>
        <Carousel.Item className="td-carousel-item">
          <Row className="pb-4 justify-content-center">
            {renderCarouselItemColumn({
              title: "Tower Defense",
              description: "Tower Defense browser game. Defend your kingdom against Slimy Empire. Endless gameplay",
              imgSrc: "towerdefense.png",
              altText: "Tower Defense screenshot",
              href: "https://towerdefense.tdbrowse.net/",
            })}
            {renderCarouselItemColumn({
              title: "CatTube",
              description: "Web application that provides quick and easy access to your favorite YouTube videos.",
              imgSrc: "cattube.png",
              altText: "CatTube screenshot",
              href: "https://cattube.tdbrowse.net/",
            })}
          </Row>
        </Carousel.Item>
      </Carousel>
    </>
  );
}
